module.exports = __webpack_public_path__ + "img/ro.69733fc9.svg";